// Aviso de erro: nenhuma ação é perdida em silêncio (AC-144).
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState, useStore } from '../state/AppStore';
import { Icon } from './Icon';

export const TOAST_MS = 5000;

export function Toast() {
  const { t } = useTranslation();
  const store = useStore();
  const toast = useAppState((s) => s.toast);
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => store.dismissToast(), TOAST_MS);
    return () => clearTimeout(id);
  }, [toast, store]);
  if (!toast) return null;
  return (
    <div className={`toast toast--${toast.kind}`} role="alert" data-testid="toast">
      <Icon name={toast.kind === 'error' ? 'alert' : 'check'} size={15} />
      <span>{t(toast.key)}</span>
      <button type="button" className="icon-btn icon-btn--sm" aria-label={t('common.close')} onClick={() => store.dismissToast()}>
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
